<template>
  <div id="resume-skills" class="col-12 bg-white-primary mx-auto">
    <div
      class="d-flex flex-column flex-md-row justify-content-md-start align-items-center border-bottom mb-1 mx-0 ps-0 ps-md-3 pe-0"
    >
      <div class="size-16 fw-bold text-center pt-4 pb-2 pb-md-4 ps-0 ps-md-2">スキル</div>
      <span class="tag-thirdly size-10 ms-2 mb-4 mb-md-0">必須</span>
    </div>
    <div class="row mx-3 py-4 gap-3">
      <div v-if="skillStore.candidate_resume_skills.length > 0" class="d-flex gap-1 gap-md-3">
        <div class="col-8 col-md-4 pe-0">
          <label class="form-label size-12 d-block" for="">スキル</label>
        </div>
        <div class="col-3 col-md-2">
          <label class="form-label size-12 d-block" for="">年数</label>
        </div>
        <div class="w-29x"></div>
      </div>
      <div
        v-if="skillError && skillStore.candidate_resume_skills.length === 0"
        class="d-block invalid-feedback"
      >
        {{ skillError }}
      </div>
      <div
        v-for="(skill, index) in skillStore.candidate_resume_skills"
        :key="index"
        class="d-flex w-100 gap-1 gap-md-3 pb-3"
      >
        <div class="col-8 col-md-4 pe-0">
          <Field v-slot="field" v-model="skill.name" :name="`skill_name_${index}`">
            <input
              type="text"
              class="input-primary form-control size-14 bg-silver-primary p-0d8"
              v-bind="field"
              disabled
            />
          </Field>
        </div>
        <div class="col-3 col-md-2 pe-0">
          <Field
            v-slot="field"
            v-model="skill.years_of_experience"
            :name="`year_of_experience_${index}`"
          >
            <select
              class="form-select select-input-primary size-14 p-0d8"
              v-bind="field"
              @change="onSelectYearWithSkill($event, skill.skill_id, skill.name ?? '')"
            >
              <option value="" disabled>年</option>
              <option
                v-for="e in yearDefault"
                :key="e.value"
                :value="e.value"
                :selected="skill.years_of_experience === e.value"
              >
                {{ e.name }}
              </option>
            </select>
          </Field>
        </div>
        <div class="d-flex justify-content-center align-items-center flex-column ms-2">
          <img
            alt="Remove icon"
            class="h-29x w-29x cursor-pointer"
            src="@/assets/images/icons/remove-icon.svg"
            @click="onRemoveSkill(skill.skill_id)"
          />
        </div>
      </div>
      <div class="row justify-content-center gap-2 w-100 m-0">
        <button
          type="button"
          class="btn btn-outline-secondary p-0d8 d-flex justify-content-center align-items-center size-12 w-12 rounded-5 h-36x"
          @click="onOpenModalSkill"
        >
          <div class="icon w-1"></div>
          <span class="ms-2">スキルを追加する</span>
        </button>
      </div>
    </div>
  </div>
  <ModalBase
    v-if="!isMobile"
    ref="modalSkillsPc"
    element="modalSkillsElement"
    title="スキルを選ぶ"
    @addItems=""
  >
    <template #body>
      <div id="skill-accordion" class="accordion accordion-primary">
        <div v-for="item in skills" :key="item.id" class="accordion-item rounded-0">
          <h4 :id="`skill-${item.id}`" class="accordion-header">
            <button
              type="button"
              class="collapsed rounded-0 bg-white accordion-button ps-5 size-14"
              data-bs-toggle="collapse"
              :data-bs-target="`#skill-item-${item.id}`"
              aria-expanded="true"
              :aria-controls="`skill-item-${item.id}`"
            >
              {{ item.name }}
            </button>
          </h4>
          <div class="row mx-2 pe-0">
            <div
              :id="`skill-item-${item.id}`"
              class="accordion-collapse collapse col-12"
              :aria-labelledby="`skill-${item.id}`"
              data-bs-parent="#skill-accordion"
            >
              <div class="w-100">
                <table class="table table-hover w-100">
                  <thead>
                    <tr>
                      <th scope="col"></th>
                      <th
                        v-for="(year, index) in [{ value: null, name: '経験なし' }, ...yearDefault]"
                        :key="year.value"
                        scope="col"
                        :class="
                          'fw-normal text-center ' + (index % 2 === 0 ? '' : 'bg-blue-secondary')
                        "
                      >
                        {{ year.name }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="skill in item.children" :key="skill.id">
                      <td>
                        <p class="fw-normal">{{ skill.name }}</p>
                      </td>
                      <td
                        v-for="(year, index) in [{ value: null, name: '経験なし' }, ...yearDefault]"
                        :key="year.value"
                        :class="'text-center ' + (index % 2 === 0 ? '' : 'bg-blue-secondary')"
                      >
                        <input
                          :id="`${skill.id}-${year.value}`"
                          class="input-primary form-check-input radio-primary-input w-1d5 h-1d5 me-2"
                          type="radio"
                          :name="'skill-year-' + skill.id"
                          :checked="handleChoiceYear(skill.id, year.value)"
                          @click="onCheckYearWithSkill(skill.id, year.value, skill.name)"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </ModalBase>
  <ModalBase
    v-else-if="isMobile"
    ref="modalSkillsMobile"
    element="modalSkillsElement"
    title="スキルを選ぶ"
    @addItems=""
  >
    <template #body>
      <div id="skill-accordion" class="accordion accordion-primary">
        <div v-for="item in skills" :key="item.id" class="accordion-item">
          <h4 :id="`skill-${item.id}`" class="accordion-header">
            <button
              type="button"
              class="collapsed rounded-0 bg-white accordion-button ps-5 size-14"
              data-bs-toggle="collapse"
              :data-bs-target="`#skill-item-${item.id}`"
              aria-expanded="true"
              :aria-controls="`skill-item-${item.id}`"
            >
              {{ item.name }}
            </button>
          </h4>
          <div
            :id="`skill-item-${item.id}`"
            class="accordion-collapse collapse col-12"
            :aria-labelledby="`skill-${item.id}`"
            data-bs-parent="#skill-accordion"
          >
            <div class="accordion-body p-0">
              <div class="accordion accordion-primary">
                <div
                  v-for="skill in item.children"
                  :key="skill.id"
                  class="accordion-item border-top-0 rounded-0"
                >
                  <h4 class="accordion-header px-3 py-2 d-flex justify-content-start">
                    <span
                      class="text-decoration-none size-14 bg-white ps-3 pe-1 d-flex align-items-center"
                    >
                      <input
                        id="skill"
                        class="input-primary form-check-input checkbox-primary-input w-1d5 h-1d5"
                        type="checkbox"
                        :name="'skill-' + skill.id"
                        :checked="handleChoiceSkill(skill.id)"
                        @click="onCheckSkill(skill.id, skill.name, $event)"
                      />
                      <span class="fw-normal size-14 ms-3">{{ skill.name }}</span>
                    </span>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </ModalBase>
</template>

<script setup lang="ts">
import { onMounted, ref, defineExpose, onUnmounted, watchEffect } from 'vue';
import { useSkillStore } from '@/stores/resume-candidate/Skill.store';
import { useFormErrorsStore } from '@/stores/resume-candidate/Errors.store';
import ModalBase from '@/components/common/ModalBase/index.vue';
import { SkillsType } from '@/types/models/skill';
import { getSkills } from '@/apis/candidate';
import { yearDefault } from '@/constant';
import { Field } from 'vee-validate';

const modalSkillsPc = ref<InstanceType<typeof ModalBase> | null>(null);
const modalSkillsMobile = ref<InstanceType<typeof ModalBase> | null>(null);
const skills = ref<SkillsType[]>([]);
const skillStore = useSkillStore();
const isMobile = ref(window.innerWidth <= 768);
const formErrorsStore = useFormErrorsStore();
const skillError = ref('');

onMounted(() => {
  const handleResize = (): void => {
    isMobile.value = window.innerWidth <= 768;
  };
  window.addEventListener('resize', handleResize);
  loadSkills();
});

onUnmounted(() => {
  const handleResize = (): void => {
    isMobile.value = window.innerWidth <= 768;
  };
  window.removeEventListener('resize', handleResize);
});

watchEffect(() => {
  skillError.value = formErrorsStore.errors.candidate_resume_skills || '';
});

const loadSkills = async (): Promise<void> => {
  const response = await getSkills();
  if (response.status === 200) skills.value = response.data;
};

const onCheckSkill = (id: number, name: string, event: Event): void => {
  const isChecked = event.target.checked;
  if (isChecked) {
    skillStore.addSkillExperience(id, name);
    // Add default year of experience
    skillStore.updateYearSkillExperience(id, 0, name);
  } else {
    onRemoveSkill(id);
  }
};

const onOpenModalSkill = (): void => {
  if (isMobile.value) {
    modalSkillsMobile?.value?.onOpen();
  } else {
    modalSkillsPc?.value?.onOpen();
  }
};

defineExpose({
  modalSkillsPc,
  modalSkillsMobile,
});

const handleChoiceYear: (id: any, year: number | null) => boolean = (id, year): boolean => {
  const skill = skillStore.candidate_resume_skills.find(
    (skill) => skill.skill_id == id && skill.years_of_experience == year
  );
  if (skill) return true;
  else if (year == null) return true;
  else return false;
};

const onCheckYearWithSkill = (id: number, year: number | null, name: string): void => {
  if (year == null) onRemoveSkill(id);
  else skillStore.updateYearSkillExperience(id, year, name);
};

const onSelectYearWithSkill = (event: any, id: number, name: string): void => {
  skillStore.updateYearSkillExperience(id, event.target.value, name);
};

const handleChoiceSkill: (id: number) => boolean = (id): boolean => {
  return skillStore.candidate_resume_skills.some((resumeSkill) => resumeSkill.skill_id === id);
};

const onRemoveSkill = (id: number): void => {
  if (skillStore.candidate_resume_skills) {
    skillStore.candidate_resume_skills = skillStore.candidate_resume_skills.filter(
      (skill) => skill.skill_id !== id
    );
  }

  // フォームから削除するとモーダルのラジオが消えるので強制的にチェックする
  const radioId = `${id}-null`;
  const radioElement = document.getElementById(radioId) as HTMLInputElement;
  if (radioElement && !radioElement.checked) {
    radioElement.checked = true;
  }
};
</script>
